export const USE_DOC_FLOW_MAPPING_TYPE_WIDGET_CHECK_PROCESS_STATUS_INTERVAL = 2000

export const USE_DOC_FLOW_MAPPING_TYPE_WIDGET_CHECK_PROCESS_STATUS_ID =
  'checkProcessProgress'
